module.exports = __webpack_public_path__ + "img/ring_g_0_1_null.ea6477a8.png";